import { useEffect } from 'react';
import { I18n } from 'i18n-js';
import _ from 'lodash';
import { systemAPI } from '../apis';
import { getCurrentLanguage } from '../utils/languageDetector';
import { LANGUAGE_ZH_HK } from '../comm/config';
import en from './locale/en.json';
import zh from './locale/zh.json';

const i18n = new I18n();

i18n.translations = {
  zh,
  en,
};

i18n.defaultLocale = 'en';

i18n.enableFallback = true;

async function loadTranslations(locale) {
  const lang = getLangWarpValue(locale);
  const response = await systemAPI.getSysGlobalFrontConfigList({ lang });
  if (response?.statusCode === '0') {
    const isVaild = _.hasIn(response?.result, 'NAV_HOME');
    if (isVaild) {
      if (lang === 'en') {
        i18n.store({ en: response?.result });
      }
      if (lang === 'tc') {
        i18n.store({ zh: response?.result });
      }
    }
  }
}

function getLangWarpValue(lang) {
  let tmpLang = 'en';
  if (lang === LANGUAGE_ZH_HK) {
    tmpLang = 'tc';
  }
  return tmpLang;
}

function useLoadTranslations() {
  useEffect(() => {
    (async () => {
      await loadTranslations(getCurrentLanguage());
    })();
  }, []);
}

export { i18n, loadTranslations, useLoadTranslations };
